<script setup>
  import {ref} from "vue";

  import PatientinputComponentBmpScannerDialog from "@pages/Patientinput/Components/Scanners/BmpScannerDialog.vue";
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputComponentStepBmp",
  });

  defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  defineEmits(["navigate"]);

  const step = ref("askBmp");
</script>

<template>
  <PatientinputComponentStep
    :forward-button="false"
    :back-button="false"
    :navigation-horizontal="false"
    :test-id="getTestId()"
  >
    <template #title>
      <Teleport defer to="#patientinput-layout-header">
        <header>
          <img src="@images/logo/mc_logo.svg" width="250" alt="MediCheck" class="mt-3" />
        </header>
      </Teleport>
    </template>

    <div v-if="step === 'askBmp'">
      <h1 class="sr-only">Liegt ein bundeseinheitlicher Medikationsplan vor? (optional)</h1>
      <p v-if="form.meta.is_patient">Haben Sie einen bundeseinheitlichen Medikationsplan (BMP, siehe Beispielfoto)?</p>

      <p v-else>Liegt ein aktueller bundeseinheitlicher Medikationsplan (BMP, siehe Beispielfoto) des Patienten vor?</p>
    </div>

    <div v-else>
      <h1 class="sr-only">Erklärung zum Scan eines bundeseinheitlichen Medikationsplans (optional)</h1>
      <p>
        Scannen Sie nun den Code auf
        <span v-if="form.meta.is_patient">Ihrem</span>
        <span v-else>dem</span>
        BMP in der rechten, oberen Ecke mit Hilfe Ihrer Gerätekamera ein, indem Sie auf „Code einscannen“ klicken.
      </p>
    </div>

    <img v-show="step === 'askBmp'" src="@images/example-bmp.jpg" alt="Beispiel-Medikationsplan" />
    <img v-show="step === 'scanBmp'" src="@images/example-bmp-marked-code.jpg" alt="Beispiel-Medikationsplan" />

    <template #navigation>
      <template v-if="step === 'askBmp'">
        <MedButton variant="primary" :data-test="getTestId('bmp-step-scan-bmp-button')" @click="step = 'scanBmp'">
          Ja
        </MedButton>
      </template>

      <template v-else>
        <MedButton
          variant="primary"
          :data-test="getTestId('bmp-step-scan-code-button')"
          @click="$refs.bmpscanner.open()"
        >
          Code einscannen
        </MedButton>
      </template>

      <MedButton :data-test="getTestId('bmp-step-without-scan-button')" @click="$emit('navigate', '+')">
        <template v-if="step === 'askBmp'">Nein</template>
        <template v-else>Ohne Scan weiter</template>
      </MedButton>
    </template>
  </PatientinputComponentStep>

  <PatientinputComponentBmpScannerDialog
    ref="bmpscanner"
    :form="form"
    :test-id="getTestId('bmp-step')"
    @ready="$emit('navigate', '+')"
  />
</template>
